import { MarkdownRenderer } from '@components/markdown-renderer';
import MED_INFO_CONTENT from '@constants/med-info-content';
import { CURRENT_INSTANCE } from '@lib/utils';
import { useTranslation } from 'react-i18next';
import AnswerMessageContainer from './answer-message-container';
import NovartisLiveChatButton from './novartis-live-chat-button';

interface IInvalidQueryResponseProps {
  userQuery?: string;
}

function InvalidQueryResponse(props: IInvalidQueryResponseProps) {
  const { t } = useTranslation();

  return (
    <AnswerMessageContainer>
      <div>
        {t('chat.response.invalid_query_intro')}
        <br />
        <br />
        <MarkdownRenderer content={MED_INFO_CONTENT[CURRENT_INSTANCE.name].de} />
        <NovartisLiveChatButton query={props.userQuery} />
      </div>
    </AnswerMessageContainer>
  );
}

export default InvalidQueryResponse;
